import React from 'react';
import Terminal from './Terminal';
import Footer from './Footer';

const App = () => {
  return (
    <div className="App">
      <Terminal />
      <Footer />
    </div>
  );
};

export default App;